/**
 * The layer over the stage until the scene has drawn its first ready frame
 * (PuttStage, App's lazy stage fallback): wordmark, "Loading the green", and
 * a thin progress line. It sits on the branded backdrop the stage now paints
 * under the canvas, so a slow TV never shows a bare rectangle.
 */
interface Props {
  /** 0..1; the line fills as the stage code, trees, and atlas land. */
  progress: number;
  /** Fading out: the scene is drawn underneath. */
  done?: boolean;
}

export default function StageLoading({ progress, done = false }: Props) {
  const percent = Math.round(Math.max(0, Math.min(1, progress)) * 100);
  return (
    <div className={`stage-loading${done ? ' done' : ''}`} role="status" aria-live="polite" aria-hidden={done}>
      <div className="brand ambient-brand">LAG<span>KING</span></div>
      <p className="stage-loading-text">Loading the green</p>
      <div className="stage-progress" aria-label={`${percent}% loaded`}>
        <i style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}
